export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAILED = 'GET_ROLES_FAILED';
export const GET_ROLES_BY_TYPE = 'GET_ROLES_BY_TYPE';
export const GET_ROLES_BY_TYPE_SUCCESS = 'GET_ROLES_BY_TYPE_SUCCESS';
export const GET_ROLES_BY_TYPE_FAILED = 'GET_ROLES_BY_TYPE_FAILED';
